import { render, staticRenderFns } from "./DeletarLista.vue?vue&type=template&id=4fabedd0&scoped=true"
import script from "./DeletarLista.vue?vue&type=script&lang=js"
export * from "./DeletarLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fabedd0",
  null
  
)

export default component.exports